import { IApplicationState } from '../../types/redux';

export const ecologyBlockActiveSelector = (state: IApplicationState) => {
  const { isEcologyBlockEnabled } = state;

  return isEcologyBlockEnabled;
};
